import PropTypes from "prop-types";
import addedToCartIcon from "../../../assets/icons/added_to_cart.svg";
import classes from "./AddedToCart.module.css";
import classNames from "classnames";

const AddedToCart = (props) => {
  const { className, isSkuAdded } = props;

  return (
    <div className={classNames(classes["added-to-cart"], className)}>
      <img
        src={addedToCartIcon}
        alt="added to cart"
        className={classes["added-to-cart__img"]}
      />
      <p className={classes["added-to-cart__text"]}>
        تم إضافة {isSkuAdded ? "المنتج" : "المجموعة"}
      </p>
    </div>
  );
};

export default AddedToCart;

AddedToCart.propTypes = {
  className: PropTypes.string,
  isSkuAdded: PropTypes.bool.isRequired,
};
